import { styled } from '@mui/material'
import IconButton from '@mui/material/IconButton'

interface RatedButton {
    selected: boolean
    selectedColor: string
}

export const RatedButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== 'selectedColor',
})<RatedButton>(({ selected, selectedColor }) => ({
    cursor: 'pointer',
    color: '#5A5F72',

    padding: 4,

    width: '24px',
    height: '24px',

    '&.Mui-disabled': {
        color: selected ? selectedColor : '#5A5F72',
    },
}))
